<template>
<div class="chapter">
<div class="inner_page">
<p class="books_by_title">Books by Clifford A. Pickover</p>
<p class="books_by"><i>The Alien IQ Test</i></p>
<p class="books_by"><i>Archimedes to Hawking</i></p>
<p class="books_by"><i>A Beginner’s Guide to Immortality</i></p>
<p class="books_by"><i>Black Holes: A Traveler’s Guide</i></p>
<p class="books_by"><i>Calculus and Pizza</i></p>
<p class="books_by"><i>Chaos and Fractals</i></p>
<p class="books_by"><i>Chaos in Wonderland</i></p>
<p class="books_by"><i>Computers, Pattern, Chaos, and Beauty</i></p>
<p class="books_by"><i>Computers and the Imagination</i></p>
<p class="books_by"><i>Cryptorunes: Codes and Secret Writing</i></p>
<p class="books_by"><i>Dreaming the Future</i></p>
<p class="books_by"><i>Egg Drop Soup</i></p>
<p class="books_by"><i>Future Health</i></p>
<p class="books_by"><i>Fractal Horizons: The Future Use of Fractals</i></p>
<p class="books_by"><i>Frontiers of Scientific Visualization</i></p>
<p class="books_by"><i>The Girl Who Gave Birth to Rabbits</i></p>
<p class="books_by"><i>The Heaven Virus</i></p>
<p class="books_by"><i>Keys to Infinity</i></p>
<p class="books_by"><i>Liquid Earth</i></p>
<p class="books_by"><i>The Lobotomy Club</i></p>
<p class="books_by"><i>The Loom of God</i></p>
<p class="books_by"><i>The Mathematics of Oz</i></p>
<p class="books_by"><i>Mazes for the Mind: Computers and the Unexpected</i></p>
<p class="books_by"><i>Mind-Bending Visual Puzzles</i> (calendars and card sets)</p>
<p class="books_by"><i>The Möbius Strip</i></p>
<p class="books_by"><i>The Paradox of God and the Science of Omniscience</i></p>
<p class="books_by"><i>A Passion for Mathematics</i></p>
<p class="books_by"><i>The Pattern Book: Fractals, Art, and Nature The Science of Aliens</i></p>
<p class="books_by"><i>Sex, Drugs, Einstein, and Elves</i></p>
<p class="books_by"><i>Spider Legs</i> (with Piers Anthony)</p>
<p class="books_by"><i>Spiral Symmetry</i> (with Istvan Hargittai)</p>
<p class="books_by"><i>Strange Brains and Genius</i></p>
<p class="books_by"><i>Sushi Never Sleeps</i></p>
<p class="books_by"><i>The Stars of Heaven</i></p>
<p class="books_by"><i>Surfing through Hyperspace</i></p>
<p class="books_by"><i>Time: A Traveler’s Guide</i></p>
<p class="books_by"><i>Visions of the Future</i></p>
<p class="books_by"><i>Visualizing Biological Information</i></p>
<p class="books_by"><i>Wonders of Numbers</i></p>
<p class="books_by"><i>The Zen of Magic Squares, Circles, and Stars</i></p>
<p class="books_by"><i>The Physics Book</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// books_by.vue?ed9fd294